<template>
  <div>
    <div class="shape-modal-wrapper">
      <div class="modal-inner">
        <div class="bm-modal-content">
          <div class="shape-modal-header">
            <div class="shape-modal-title">
              <h2>Svg Library</h2>
              <p class="mt-2">Click a shape to add it to the page.</p>
            </div>

            <button
                type="button"
                class="shape-close-btn"
                aria-label="Close"
                @click="handleModalClose"
            >
              <icon name="close-icon" />
            </button>
          </div>
          <div class="shape-modal-body">

            <div class="shape-categories">
              <button
                  type="button"
                  class="category-pill"
                  :class="{ selected: getSVGCategoryFilter === '' }"
                  @click="filterShapes('')"
              >
                All
              </button>

              <button
                  v-for="category in getSVGShapeCategories"
                  :key="'category-' + category.Id"
                  type="button"
                  class="category-pill"
                  :class="{
              selected: getSVGCategoryFilter === category.Id
            }"
                  @click="filterShapes(category.Id)"
              >
                <img
                    :src="category.VirtualPath"
                    class="shape-category-icon"
                />

                {{ category.Name }}
              </button>

            </div>

            <div
                v-if="isLoading"
                class="shape-loading"
            >
              <Spinner
                  :speed="1"
                  size="large"
                  font-size="11px"
                  message="Loading SVG Shapes..."
              />
            </div>

            <div
                v-if="getSvgShapes.length < 1 && !isLoading"
                class="shape-empty"
            >
              No Suitable Shapes in the Library
            </div>

            <div
                v-if="getSvgShapes.length && !isLoading"
                class="shape-grid"
            >
              <button
                  v-for="(image, i) in getSvgShapes"
                  :key="i"
                  type="button"
                  class="shape-card"
                  :class="{
              selected: selectedShape.Title === image.Title
            }"
                  :aria-label="`Insert ${image.Title} shape`"
                  @click.stop="
              selectingShape({
                VirtualPath: image.VirtualPath,
                Title: image.Title
              })
            "
              >
                <img
                    :src="image.VirtualPath"
                    :alt="image.Title"
                />
              </button>
            </div>

          </div>

        </div>
      </div>

      <div
          class="backdrop"
          @click="handleModalClose"
      />
    </div>
  </div>
</template>

<script>
import ThumbnailBox from '@/components/ThumbnailBox/ThumbnailBox.vue';
import axios from 'axios';
import EventBus from '@/EventBus';
import _ from 'lodash';
import {
  fetchingSvg, convertingDifferentMeasurementUnitIntoPx,
} from '@/components/Helper';
import Spinner from 'vue-simple-spinner';

export default {
  name:       'ShapeModal',
  components: { 'thumbnail-box': ThumbnailBox, Spinner },
  data() {
    return {
      isShapeModalShown: false,
      selectedShapeData: {},
      svgShapes:         [],
      selectedShape:     { Title: '', VirtualPath: '' },
      isLoading:         false,
    };
  },
  computed: {
    getSVGShapeCategories() {
      return this.$store.getters.getSVGCategories;
    },
    getSvgShapes() {
      return this.$store.getters.getProductSvg;
    },
    getSVGCategoryFilter() {
      return this.$store.getters.getSVGCategoryFilter;
    },
  },
  mounted() {
    this.fetchSVGShape();
    this.filterShapes('');
  },
  methods: {
    async filterShapes(categoryId) {
      this.$store.commit('updataProductSvg', []);
      this.$store.commit('setSVGCategoryFilter', categoryId);
      const method     = (categoryId == '') ? 'GetSvgShapesByBank' : 'GetShapesByCategory';
      const parentNode = (categoryId == '') ? 'GetSvgShapesByBankResult' : 'GetShapesByCategoryResult';
      const domainUrl  = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url        = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=${method}&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/&categoryId=${categoryId}`;
      this.isLoading   = true;
      const parser     = new DOMParser();
      axios.get(url)
        .then((response) => {
          console.log(response);

          const xmlParsed   = parser.parseFromString(response.data, 'text/xml');
          let svgCollection = xmlParsed.getElementsByTagName(parentNode);
          svgCollection[0] && (svgCollection = svgCollection[0].innerHTML);
          const parse = JSON.parse(svgCollection);
          this.$store.commit('updataProductSvg', parse);
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          const temp = [{
            Id:           '1ff3ca30-2569-41c5-ab1e-006bc5c608c3',
            Title:        '42',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202206/Shapes_42.svg',
            CategoryName: 'Frames \u0026 Borders',
            CategoryId:   'a1b1acd8-8c1d-4c60-87f0-a25a321a3660',
          },
          {
            Id:           'c0d428b2-28cc-45e8-86f1-00c6bdf36cf7',
            Title:        '21',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202111/21.svg',
            CategoryName: 'Frames \u0026 Borders',
            CategoryId:   'a1b1acd8-8c1d-4c60-87f0-a25a321a3660',
          },
          {
            Id:           '67b4cd44-b9e9-4c43-afc3-022bf8725394',
            Title:        '31',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202205/MiscShapes-01.svg',
            CategoryName: 'Lines \u0026 Swooshes',
            CategoryId:   '0c3b1018-0f7f-4cb1-9f7d-d031c18160bf',
          },
          {
            Id:           'aa083791-fe08-4047-ac1f-03420d533955',
            Title:        '58',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202206/Shapes_58.svg',
            CategoryName: 'Bubbles',
            CategoryId:   'fbbcfcb4-4e7e-480c-84be-35d814e70270',
          },
          {
            Id:           '96f6bc05-98fc-4f6b-8e4f-052995791312',
            Title:        'LinkedIn',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202209/LinkedIn-0107.svg',
            CategoryName: 'Logos',
            CategoryId:   'eaabe57a-e7a5-4288-89b1-e6e7d7b72f14',
          },
          {
            Id:           '78094b85-2fbf-4e73-a83b-084a9e87f1ba',
            Title:        'TM Icon',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202210/Icons_TM.svg',
            CategoryName: 'Icons',
            CategoryId:   'eca9a7d3-233a-4987-bc48-cc81245c33ba',
          },
          {
            Id:           'ac7a6723-f873-4558-871d-12d9551be6bf',
            Title:        '39',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202206/Shapes_39.svg',
            CategoryName: 'Arrows',
            CategoryId:   'dfd8ef5c-a5a0-4de0-ad2b-39f27e0a23ed',
          },
          {
            Id:           'dbfcfaf4-3d44-45f7-95d7-149678ab7d77',
            Title:        '65',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202209/Hollow%20Square%20Icon-01.svg',
            CategoryName: 'Frames \u0026 Borders',
            CategoryId:   'a1b1acd8-8c1d-4c60-87f0-a25a321a3660',
          },
          {
            Id:           '75524fb4-68c7-415d-aff4-14c5d041de6d',
            Title:        'LinkedIn 2',
            VirtualPath:  'https://www.bankmarketingcenter.com/upload/files/202212/LinkedIn-02.svg',
            CategoryName: 'Logos',
            CategoryId:   'eaabe57a-e7a5-4288-89b1-e6e7d7b72f14',
          }];

          this.$store.commit('updataProductSvg', temp);
          this.isLoading = false;
        });
    },

    handleModalClose() {
      this.$store.commit('setShapeModel', false);
      this.isShapeModalShown = !this.isShapeModalShown;
    },
    fetchSVGShape() {
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SearchSvgShapeCategory&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        console.error('loading SVG categories', Response);
        const parser      = new DOMParser();
        const xmlParsed   = parser.parseFromString(Response.target.response, 'text/xml');
        let svgCollection = xmlParsed.getElementsByTagName('SearchSvgShapeCategoryResult');
        svgCollection[0] && (svgCollection = svgCollection[0].innerHTML);
        const parse = JSON.parse(svgCollection);
        this.$store.commit('updateSVGCategories', parse);
      });
      oReq.addEventListener('error', (e) => {
        console.log('Error in loading Categories', e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    selectingShape(data) {
      this.selectedShape = _.cloneDeep(data);
      this.$nextTick(() => {});
      this.addShape();
    },

    async addShape(data) {
      if (!this.selectedShape.Title) {
        alert('Please select the shape');
        return;
      }
      const shapeInput = await fetchingSvg(this.selectedShape.VirtualPath);
      this.handleModalClose();
      const style        = `style="transform-origin: left top; transform: scale(${1}, ${1});"`;
      shapeInput.content = shapeInput.content.includes('style="transform-origin: left top 0px;"') ? shapeInput.content.replace('style="transform-origin: left top 0px;"', style) : shapeInput.content.replace('style="transform-origin: left top;"', style); // check for the browser compatibility
      // shapeInput.content = shapeInput.content.replace()
      EventBus.$emit('AddSvgShape', {
        content: shapeInput.content, name:    this.selectedShape.Title, color:   'rgb(0,0,0)', width:   convertingDifferentMeasurementUnitIntoPx(shapeInput.width), height:  convertingDifferentMeasurementUnitIntoPx(shapeInput.height),
      });
    },
  },
};

</script>

<style lang="scss" scoped>
.shape-modal-wrapper {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-inner {
  position: relative;
  z-index: 99;
  width: 880px;
  max-width: calc(100% - 32px);
}
.bm-modal-content {
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  background: #fff;
  border-radius: 16px;
  box-shadow:
      0 0 0 1px rgba(16, 24, 40, 0.06),
      0 24px 64px rgba(16, 24, 40, 0.28);
  display: flex;
  flex-direction: column;
}
.shape-modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 20px 0 24px;
}
.shape-modal-title {
  flex-grow: 1;
  min-width: 0;
  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: #14161b;
  }
  p {
    margin: 4px 0 0;
    font-size: 13px;
    line-height: 1.45;
    color: #5e6573;
  }
}
.shape-close-btn {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #3d4350;
  cursor: pointer;

  &:hover {
    background: #f5f6f8;
  }

  .icon {
    display: flex !important;
  }
}
.shape-modal-body {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}
.shape-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.category-pill {
  height: 34px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  border: 0;
  border-radius: 999px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  background: #fff;
  color: #14161b;
  box-shadow: inset 0 0 0 1px #e7e9ed;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    background: #f8f9fb;
  }
  &.selected {
    background: #1570ef;
    color: #fff;
    box-shadow: none;
    font-weight: 600;
  }
}
.shape-category-icon {
  width: 15px;
  height: 15px;
  object-fit: contain;
}
.shape-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}
.shape-card {
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: #fff;
  color: #14161b;
  box-shadow: inset 0 0 0 1px #e7e9ed;
  cursor: pointer;
  transition:
      box-shadow 0.15s ease,
      transform 0.15s ease,
      background 0.15s ease;
  &:hover {
    box-shadow: rgb(21, 112, 239) 0px 0px 0px 2px;
    background: rgb(234, 242, 254);
  }

  &.selected {
    background: #eaf2fe;
    box-shadow:
        inset 0 0 0 2px #1570ef;
  }

  img {
    width: 48px !important;
    height: 48px !important;
    object-fit: contain !important;
  }
}
.shape-loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shape-empty {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #5e6573;
}

.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(16, 24, 40, 0.35);
  z-index: 0;
}
@media (max-width: 700px) {
  .modal-inner {
    width: calc(100% - 24px);
  }
  .shape-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 480px) {
  .shape-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

</style>
